// Iter 128 — Currency catalogue + display helpers.
// Per-user preferred currency lives on user.currency (synced via PATCH /api/me/currency).
// Display-only — we never convert amounts.  The user is responsible for entering
// amounts in their chosen currency.

export const CURRENCIES = [
  { code: "USD", symbol: "$",   name: "US Dollar",            flag: "🇺🇸", prefix: true },
  { code: "EUR", symbol: "€",   name: "Euro",                 flag: "🇪🇺", prefix: true },
  { code: "GBP", symbol: "£",   name: "British Pound",        flag: "🇬🇧", prefix: true },
  { code: "CAD", symbol: "C$",  name: "Canadian Dollar",      flag: "🇨🇦", prefix: true },
  { code: "ZAR", symbol: "R",   name: "South African Rand",   flag: "🇿🇦", prefix: true },
  { code: "KES", symbol: "KSh", name: "Kenyan Shilling",      flag: "🇰🇪", prefix: true },
  { code: "NGN", symbol: "₦",   name: "Nigerian Naira",       flag: "🇳🇬", prefix: true },
  { code: "GHS", symbol: "₵",   name: "Ghanaian Cedi",        flag: "🇬🇭", prefix: true },
  { code: "XOF", symbol: "CFA", name: "West African CFA",     flag: "🌍", prefix: false },
];

export const getCurrency = (code) =>
  CURRENCIES.find((c) => c.code === (code || "USD").toUpperCase()) || CURRENCIES[0];

// Formats a number using the chosen currency's symbol/placement.
// Examples:
//   USD: +$67, -$1.2k
//   XOF: +67 CFA, -1.2k CFA
//   GHS: +₵67
export const fmtAmount = (value, code = "USD", { compact = true } = {}) => {
  if (value === null || value === undefined || isNaN(value)) return "—";
  const c = getCurrency(code);
  const v = Number(value);
  const abs = Math.abs(v);
  const sign = v > 0 ? "+" : v < 0 ? "-" : "";
  let body;
  if (compact && abs >= 1000) {
    body = `${(abs / 1000).toFixed(1)}k`;
  } else {
    body = abs.toFixed(abs >= 100 ? 0 : 2);
  }
  return c.prefix ? `${sign}${c.symbol}${body}` : `${sign}${body} ${c.symbol}`;
};
